export default "__VITE_ASSET__teRm4bjx__"